import { Outlet } from "@remix-run/react"
import { Logo } from "~/components/ui/logo"

export default function AuthLayout() {
    return (
        <div className="container max-w-lg mx-auto h-screen flex">
            <div className="m-auto w-full px-8 py-12 bg-white">
                <div className="mb-4 w-2/5 mx-auto">
                    <Logo />
                </div>
                <div>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}
